import { useMemberExtract } from 'contexts/MemberExtract';
import React from 'react';
import Body from './Body';
import Header from './Header';

function Card() {
  const { isEmptyExtract, loading } = useMemberExtract();

  if (loading && isEmptyExtract) {
    return null;
  }

  return (
    <div className={`corporate-club-extract__card ${isEmptyExtract ? 'corporate-club-extract__card--empty' : ''}`}>
      <Header />
      <Body />
    </div>
  );
}

export default Card;
